import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { SectionHeading, Watermark } from '../components/Section';
import { whyAqc, aboutImage } from '../data/mock';
import SEO from '../lib/SEO';

export default function WhyAqc() {
  const stats = [
    { k: '10+', v: 'Countries Coverage' },
    { k: '8', v: 'Industries Served' },
    { k: '24h', v: 'Report Turnaround' },
    { k: '72h', v: 'On-site Response' },
  ];
  return (
    <div className="font-sans-body">
      <SEO />
      <section className="relative overflow-hidden">
        <Watermark opacity={0.04} />
        <div className="container-aqc relative py-16 lg:py-20 text-center">
          <span className="eyebrow">Why AQC</span>
          <h1 className="mt-5 font-serif text-[2.4rem] sm:text-[3rem] leading-[1.08] font-semibold text-aqc-navy max-w-3xl mx-auto">
            Why global brands and startups <span className="italic text-aqc-red">choose AQC.</span>
          </h1>
        </div>
      </section>

      <section className="py-12 bg-aqc-cream">
        <div className="container-aqc grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {stats.map((s) => (
            <div key={s.v} className="bg-white border border-aqc-line rounded-2xl p-6 text-center card-lift">
              <div className="font-serif text-4xl text-aqc-navy">{s.k}</div>
              <div className="mt-2 text-aqc-muted text-sm">{s.v}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16">
        <div className="container-aqc grid lg:grid-cols-2 gap-12 items-center">
          <img src={aboutImage} alt="AQC coordination" className="rounded-2xl w-full h-[440px] object-cover shadow-[0_30px_60px_-30px_rgba(15,42,71,0.4)]" />
          <div>
            <SectionHeading center={false} title="Six reasons partners stay with AQC." />
            <ul className="mt-8 space-y-4">
              {whyAqc.map((w) => (
                <li key={w.title} className="flex items-start gap-3">
                  <div className="mt-1 h-5 w-5 rounded-full bg-aqc-red/12 flex items-center justify-center shrink-0">
                    <CheckCircle2 size={14} className="text-aqc-red" />
                  </div>
                  <p className="text-[0.98rem] leading-relaxed">
                    <span className="font-semibold text-aqc-navy">{w.title}</span>{' '}
                    <span className="text-aqc-muted">{w.body}</span>
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="py-14 bg-aqc-navy text-white">
        <div className="container-aqc text-center">
          <h2 className="font-serif text-3xl">Talk to an AQC coordinator today.</h2>
          <div className="mt-6"><Link to="/contact"><Button className="bg-aqc-red hover:brightness-110 text-white h-11 px-6">Contact Us</Button></Link></div>
        </div>
      </section>
    </div>
  );
}
